import { styled } from 'styled-components';

interface IStyledProps {
    isSelected: boolean;
}

export const PaymentMethodButton = styled.div<IStyledProps>`
    width: 100%;
    padding: 6px 10px;
    border: 2px solid ${(props) => (props.isSelected ? '#1976D2' : '#ccc')};
    border-radius: 10px;
    height: auto;
    cursor: pointer;
    box-shadow: 1px 2px 5px #aaa;
    > img {
        display: block;
        height: 20px;
        width: 20px;
        margin-bottom: 2px;
    }
    span {
        display: block;
        font-size: 14px;
        line-height: 16px;
    }
`;
